import AppGridContainer from "@crema/core/AppGridContainer";
import { Box, Button, FormHelperText, Grid, TextField } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { wishUserBday } from "redux/actions/Home";
const validationSchema = yup
    .object()
    .shape({
        message: yup
            .string()
            .trim()
            .required("Please enter message")
            .min(3, "Message should be greater than 3 characters")
            .max(500, "Message should be less than 500 characters"),
    })
    .required();
export default function UpcomingBirthdayForm(props) {
    const { setOpen, userDetails } = props;
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            message: `Sending your way birthday wishes for a beautiful year ahead. May your lucky stars continue to shine and make all your dreams come true,Enjoy your day  
            `,
        },
        resolver: yupResolver(validationSchema),
    });
    const dispatch = useDispatch();
    const onSubmit = (data) => {
        const payload = {
            userId: userDetails.userid,
            message: data.message,
            email: userDetails.email,
            fname: userDetails.fname,
        };
        dispatch(wishUserBday(payload, setOpen));
    };
    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>
                <AppGridContainer spacing={2} sx={{ pt: 2 }}>
                    <Grid item xs={12}>
                        <TextField
                            {...register("message")}
                            name="message"
                            type="text"
                            fullWidth
                            label="Message *"
                            id="Message"
                            multiline
                            rows={5}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText error={true}>
                            {errors.message?.message}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => setOpen(false)}
                                sx={{
                                    mr: 2,
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                type="submit"
                                variant="contained"
                            >
                                Send
                            </Button>
                        </Box>
                    </Grid>
                </AppGridContainer>
            </form>
        </Box>
    );
}
UpcomingBirthdayForm.propTypes = {
    setOpen: PropTypes.func.isRequired,
    userDetails: PropTypes.object.isRequired,
};
